const CHECKBOX_MENU = 'checkbox-menu'

export const DESKTOP_COPY_ID = `${CHECKBOX_MENU}-desktop-copy-button`
export const MOBILE_MORE_MENU_ID = `${CHECKBOX_MENU}-mobile-more-menu`
